import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setEmail } from "../../../redux/slices/authSlice";
import BackButton from "../../../components/BackButton";
import NextButton from "../../../components/NextButton";
import InputField from "../../../components/InputField";
import AuthCard from "../../../components/AuthCard";
import { sendOtp, OTP_TYPE } from "./services/authServices";
import { showNotification } from "../../../redux/slices/notificationSlice";

export default function SignUpEmail() {
  const storedEmail = useSelector((state) => state.auth.email);
  const [localEmail, setLocalEmail] = useState(storedEmail || "");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = async () => {
    if (isSubmitting) return;
    const trimmed = localEmail.trim();
    // If no email provided, skip email verification and move to mobile step
    if (!trimmed) {
      dispatch(setEmail(""));
      navigate("/auth/add-mobile-number");
      return;
    }

    try {
      setIsSubmitting(true);
      await sendOtp(trimmed, OTP_TYPE.EMAIL);
      dispatch(
        showNotification({
          message: t("verificationEmailSent"),
          type: "success",
        })
      );
      dispatch(setEmail(trimmed));
      navigate("/auth/verify-email");
    } catch (err) {
      console.error("Failed to register email:", err);
      dispatch(
        showNotification({
          message: t("sendVerificationCodeFail"),
          type: "error",
        })
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50 animate-fade-in">
      <AuthCard>
        <BackButton />

        <h2 className="sub-header mb-4">{t('signUpPrompt')}</h2>

        <label className="block text-sm font-medium mb-1">
          {t('emailAddress')}
        </label>
        <InputField
          type="email"
          value={localEmail}
          onChange={(e) => setLocalEmail(e.target.value)}
          placeholder={t('enterEmail')}
        />

        <NextButton
          onClick={handleSubmit}
          className="mt-6"
          loading={isSubmitting}
          loadingLabel={t("loading")}
        />
      </AuthCard>
    </div>
  );
}
